import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from 'lz-string'

import { stringify, parse } from 'zipson'
import { groupDimensions } from '@/utils/dimensionUtils.js'
const funcReplacer = (key, value) => (value instanceof Function ? null : value)

export function filtersToString(filters) {
  let plain = JSON.parse(JSON.stringify(filters, funcReplacer))
  let str = stringify(plain, { detectUtcTimestamps: false })
  // str = str.replaceAll('T00:00:00Z', 'TZ')
  return compressToEncodedURIComponent(str)
  // return encodeToBinary(encodeURIComponent(str))
  // parse(decodeURIComponent(decodeFromBinary(value))),
}
export function stringToFilters(str) {
  // let decoded = decodeURIComponent(decodeFromBinary(str))
  let decoded = decompressFromEncodedURIComponent(str)
  return parse(decoded, { detectUtcTimestamps: false })
}

var jd = require('@clipchamp/json-delta')

function removeAlls(obj, dimensions) {
  let groupedDimensions = groupDimensions(dimensions)
  obj = JSON.parse(JSON.stringify(obj))
  obj.dimensions.forEach(dim => {
    // console.log('checking all', dim)
    if (groupedDimensions.dimensionOptions[dim.id]) {
      let typeDim = obj.dimensions.find(d => d.id === dim.id + '_type')

      if (typeDim) {
        let dimOptions = groupedDimensions.dimensionOptions[dim.id]
        let compressedValues = []
        dimOptions.forEach(opts => {
          if (
            opts.values.length > 0 &&
            opts.values.every(o => dim.values.find(oo => oo.value === o.id))
          ) {
            // console.log('is ALL', opts.values, dim.values)
            compressedValues.push({ id: '__ALL__', type: opts.type })
          } else {
            compressedValues = compressedValues.concat(dim.values.filter(v => v.type === opts.type))
          }
        })
        dim.values = compressedValues
      } else {
        if (
          dimensions.dimensionOptions[dim.id].every(o => dim.values.find(oo => oo.value === o.id))
        ) {
          // console.log('is ALL', dimensions.dimensionOptions[dim.id], dim.values)
          dim.values = [{ id: '__ALL__' }]
        } else {
          //donothing (dejalos dim.values como estaban)
        }
      }
    }
  })
  return obj
}
function optToValue(o) {
  return {
    value: o.id,
    type: o.type,
  }
}
function readdAlls(obj, dimensions) {
  let groupedDimensions = groupDimensions(dimensions)
  obj = JSON.parse(JSON.stringify(obj))
  obj.dimensions.forEach(dim => {
    let decompressedValues = []
    dim.values.forEach(d => {
      if (d.id === '__ALL__') {
        let dimOptions = groupedDimensions.dimensionOptions[dim.id]
        let vals = dimOptions.find(g => g.type === d.type).values.map(o => optToValue(o))
        decompressedValues = decompressedValues.concat(vals)
      } else {
        decompressedValues.push(d)
      }
    })
    dim.values = decompressedValues
  })
  return obj
}
export function getDiffs(oldObj, newObj, dimensions) {
  newObj = removeAlls(newObj, dimensions)
  let diffs = jd.diff(oldObj, newObj)
  return diffs
}

export function applyDiffs(oldObj, diffs, dimensions) {
  let newObj = jd.applyDiff(JSON.parse(JSON.stringify(oldObj)), diffs)
  newObj = readdAlls(newObj, dimensions)
  return newObj
}
